var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_593_1101)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 35,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.0326 25.0015C42.0326 25.0015 42.0213 25.0015 42.0156 25.0015C42.0099 25.0015 42.0057 25.0015 42.0014 25.0015C41.9943 25.0015 41.9887 25.0015 41.9816 25.0015C41.9788 25.0015 41.9773 25.0015 41.9745 25.0015C32.6118 25.0156 25 32.6345 25 42C25 42.248 25.0057 42.493 25.0156 42.7381C25.0326 43.1277 25.3428 43.3955 25.7537 43.4167C26.1447 43.3997 26.4478 43.0696 26.4323 42.6786C26.4223 42.4534 26.4167 42.2281 26.4167 42C26.4167 39.9997 26.8091 38.0929 27.499 36.3334H34.4506C34.2423 36.9765 34.0525 37.631 33.9052 38.3096C33.8216 38.6921 34.0936 39.1667 34.5965 39.1667C34.9223 39.1667 35.217 38.94 35.2878 38.6071C35.4564 37.8251 35.6831 37.0686 35.9423 36.3334H48.0492C48.6697 38.0985 49.0833 40.0068 49.0833 42C49.0833 43.9933 48.6697 45.9001 48.0478 47.6667H45.5417C45.1507 47.6667 44.8333 47.9841 44.8333 48.3751C44.8333 48.7661 45.1507 49.0834 45.5417 49.0834H47.4924C45.5643 53.5346 42.4944 56.7957 41.7138 57.5763C41.5821 57.5735 41.4503 57.5735 41.32 57.5678C40.9219 57.5621 40.5989 57.8568 40.5819 58.2464C40.5663 58.636 40.8695 58.9675 41.2605 58.9845C41.5056 58.9944 41.7507 59.0001 41.9986 59.0001C51.3727 59.0001 58.9986 51.3741 58.9986 42C58.9986 32.626 51.3911 25.0199 42.0326 25.0015ZM34.962 34.9167H28.1365C30.4683 30.3735 34.9549 27.118 40.2462 26.5215C38.8054 28.1408 36.4764 31.13 34.962 34.9167ZM36.492 34.9167C38.2288 30.9019 40.9148 27.8518 42 26.7156C43.0795 27.8447 45.7556 30.892 47.4967 34.9167H36.492ZM49.0423 34.9167C47.5307 31.1356 45.2003 28.1436 43.7553 26.523C49.0451 27.1194 53.5317 30.3749 55.8621 34.9167H49.0423ZM43.7553 57.4771C45.1988 55.8565 47.5293 52.8645 49.0423 49.0834H55.8621C53.5317 53.6252 49.0451 56.8807 43.7553 57.4771ZM49.5508 47.6667C50.1218 45.8987 50.4986 43.999 50.4986 42C50.4986 40.0011 50.1232 38.1014 49.5508 36.3334H56.4996C57.1895 38.0929 57.5819 39.9997 57.5819 42C57.5819 44.0004 57.1895 45.9072 56.4996 47.6667H49.5508ZM42.391 41.6218C41.4305 40.6613 40.0294 40.3411 38.7332 40.776C38.7133 40.7831 26.2594 46.4385 26.2594 46.4385C25.5185 46.7742 25.0298 47.5194 25.0142 48.334C25 49.1471 25.4604 49.9079 26.1886 50.2734L28.9341 51.6461L25.6701 54.8931C24.7337 55.8296 24.7337 57.3539 25.6701 58.2931C26.6079 59.231 28.1351 59.2296 29.0701 58.2931L32.3454 55.032L33.738 57.8228C34.1021 58.5467 34.8303 58.9958 35.6774 58.9958C36.492 58.9802 37.2372 58.4929 37.5729 57.7506L43.1843 45.4015C43.6688 44.0131 43.3728 42.5979 42.3896 41.619L42.391 41.6218ZM41.8725 44.8773L36.2852 57.1669C36.1733 57.4148 35.9253 57.5777 35.6406 57.582C35.3714 57.582 35.1278 57.4318 35.0073 57.191L33.1756 53.5246C33.075 53.3206 32.8625 53.118 32.5423 53.1336C32.3568 53.1336 32.1754 53.2073 32.0423 53.3405L28.0713 57.2944C27.6874 57.6783 27.057 57.6783 26.6731 57.2944C26.2892 56.9091 26.2892 56.2815 26.6731 55.899L30.6341 51.9578C30.7956 51.7977 30.8707 51.5682 30.8338 51.343C30.7984 51.1177 30.6553 50.9236 30.4513 50.8216L26.8247 49.0097C26.5824 48.8879 26.428 48.6329 26.4337 48.3623C26.4379 48.0917 26.6008 47.8438 26.8488 47.7319L39.1993 42.119C39.977 41.857 40.8171 42.0482 41.3923 42.6262C41.9887 43.2226 42.1558 44.0655 41.8753 44.8801L41.8725 44.8773Z",
    fill: "#00715D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_593_1101",
    x: 0,
    y: 0,
    width: 86,
    height: 86,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_593_1101"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_593_1101",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.abc01b634ff7ddf7277688c04d31b386.svg";
export { ForwardRef as ReactComponent };